import { render, staticRenderFns } from "./TeacherReview.vue?vue&type=template&id=28987566&scoped=true"
import script from "./TeacherReview.vue?vue&type=script&lang=js"
export * from "./TeacherReview.vue?vue&type=script&lang=js"
import style0 from "./TeacherReview.vue?vue&type=style&index=0&id=28987566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28987566",
  null
  
)

export default component.exports